import React from 'react';
import moment from 'moment';
import { Typography, Box } from '@material-ui/core';
import Loader from '../../Loader';
import { useStyles } from '../style';
import { declOfNum } from '../../../utils/declOfNum';

const TotalRentDays = ({ loading, rentDays }) => {
    const classes = useStyles();
    const year = moment().format('YYYY');

    return (
        <>
            <Typography className={classes.heading}>Всего арендодней за {year}</Typography>
            {loading && <Loader p={1} size={40} />}
            {!loading && (
                <Box display="flex" flexDirection="row" alignItems="flex-end">
                    <Typography className={classes.value}>{rentDays || '-'} </Typography>
                    <Typography className={classes.label}> {declOfNum(rentDays || 0, ['день', 'дня', 'дней'])}</Typography>
                </Box>
            )}
        </>
    );
};

export default TotalRentDays;
